import { render, staticRenderFns } from "./AddControlLot.vue?vue&type=template&id=edcb31ae&"
import script from "./AddControlLot.vue?vue&type=script&lang=js&"
export * from "./AddControlLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports